export const CashPickupTemplate = {
    name: 'cash_pickup',
    label: 'Cash Pickup',
    subject: "REBIT ${reference}: Cash pickup instructions",
    category: 'compulsory',
    body: "<style>.afghanistan:not([data-name=\"Afghanistan\"]){display: none} .iraq:not([data-name=\"Iraq\"]){display: none} .turkey:not([data-name=\"Turkey\"]){display: none}</style>" +
        "<p>Hi ${payer_first_name},</p>" +
        "<p>We have sent your ${received_amount} ${dest_currency} to ${dest_country_name}.</p>" +
        "<p><b>What is next?</b></p>" +

        "<div class='afghanistan' data-name='${dest_country_name}'>" +
        "<p>Your recipient, ${recipient_name}, should receive the pickup instructions including an order number and pickup location, via a phone call or WhatsApp voice message made by the exchange shop within 24 hours from receipt of this email.</p>" +
        "<p>Correspondent contact number: +93787787722</p>" +
        "<p>In case ${recipient_name} missed our call/msg they can confirm the pickup details, by contacting the above number.<br>However, For security reasons, money-related details won't be communicated over phone.</p>" +
        "<p><b>Some of our main pickup locations are as follows:</b></p>" +
        "<ul>" +
        "<li>Kabul: Shop # C69, 3rd floor, Gulbahar business centre, opposite to Ministry of Education, Malak Asghar square, Kabul.</li>" +
        "<li>Mazar-i-Sharif: Please contact the above number.</li>" +
        "<li>Herat: Please contact the above number.</li>" +
        "<li>Kandahar: Please contact the above number.</li>" +
        "<li>Jalalabad: Please contact the above number.</li>" +
        "</ul>" +
        "</div>" +

        "<div class='iraq' data-name='${dest_country_name}'>" +
        "<p>Please pass the following information to ${recipient_name}. These are required for cash pick-up in Iraq.</p>" +
        "<ul>" +
        "<li><b>Pickup exchange shop:</b></li>" +
        "<li><b>Pickup address:</b></li>" +
        "<li><b>Secret code:</b></li>" +
        "</ul>" +
        "<p>Your recipient's mobile number: ${recipient_account_notes}</p>" +
        "</div>" +

        "<div class='turkey' data-name='${dest_country_name}'>" +
        "<p>Please pass the following information to ${recipient_name}. These are required for cash pick-up in Turkey.</p>" +
        "<ul>" +
        "<li><b>Pickup address:</b></li>" +
        "<li><b>Secret code:</b></li>" +
        "</ul>" +
        "<p>Your recipient's mobile number: ${recipient_account_notes}</p>" +
        "</div>" +

        "<p>Thanks for using Rebit! <br>" +
        "For enquiries please hit reply and write to support@rebit.co.nz.</p>"
}

